export const DEFAULT_BADGE_TITLE = "Mode: Default"
export const DEFAULT_BADGE_DESCRIPTION = "Uses INTPA Virtual Library and optional web"
